// React i hooks
import { memo, useEffect, useState } from "react";

// API servisi


import { Errors } from "services/forms/validation/types";
import { validateYup } from "services/forms/validation/validation";

import {
  useHandleTextFieldChange,
} from "services/forms/hooks";

// Tipovi i konstante
import { TranslationEditProps } from "./types";
import { TRANSLATION_EDIT_FORM_SCHEMA } from "./validation";

// UI komponente
import { Button } from "ui/components/Button/Button";
import { TextField } from "ui/components/TextField/TextField";
import { Loader } from "ui/components/Loader";
import { useTranslate } from "helpers";
import {
  createTranslationAPI,
  getTranslationAPI,
  updateTranslationAPI,
} from "services/api/translations/api";
import { TranslationEditFormValues } from "services/api/translations/types";
import { initialTranslationEditForm } from "services/api/translations/consts";

const TranslationEditCard: React.FC<TranslationEditProps> = (props) => {
  const { languageId, translationId, onSuccess, onClose } = props;

  const { t } = useTranslate();
  const [errors, setErrors] = useState<Errors>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [formValues, setFormValues] = useState<TranslationEditFormValues>(
    initialTranslationEditForm
  );

  useEffect(() => {
    fetchTranslation(translationId, languageId);
  }, [translationId, languageId]);

  const fetchTranslation = async (
    id: string | null,
    languageId: string | null
  ) => {
    if (!id) {
      setFormValues((old) => ({
        ...old,
        key: "",
        value: "",
        translationLanguageId: languageId,
      }));
      return;
    }

    setIsLoading(true);

    let result;
    try {
      result = await getTranslationAPI(id);
    } catch {
      setIsLoading(false);
      return;
    }

    setFormValues(result);

    setIsLoading(false);

    setErrors({});
  };

  const handleFormSubmit = async (e: any) => {
    e.preventDefault();

    const isValid = validateYup(
      formValues,
      TRANSLATION_EDIT_FORM_SCHEMA,
      setErrors
    );

    if (!isValid) {
      return;
    }

    setIsLoading(true);

    try {
      let result;
      if (!!translationId) {
        result = await updateTranslationAPI(translationId, formValues);
      } else {
        result = await createTranslationAPI(formValues);
      }

      if (result && onSuccess) onSuccess();
    } catch (e) {
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
  };

  const handleTextFieldChange = useHandleTextFieldChange(
    setFormValues,
    formValues
  );

  return (
    <>
      <div className="flex gap-4">
        <div className="h-screen w-full m-auto">
          <div className="flex gap-3 h-full">
            <form noValidate className="text-left flex-1 p-4">
              <div className="flex gap-3">
                <div className="flex-1">
                  <TextField
                    type="text"
                    name="key"
                    label={t("admin.sidebar.translation.add.key")}
                    placeholder={t(
                      "admin.sidebar.translation.add.key.placeholder"
                    )}
                    onChange={handleTextFieldChange}
                    error={errors.key}
                    value={formValues.key}
                    required
                    endIcon=""
                  ></TextField>
                </div>
                <div className="flex-1">
                  <TextField
                    type="text"
                    name="value"
                    label={t("admin.sidebar.translation.add.value")}
                    placeholder={t(
                      "admin.sidebar.translation.add.value.placeholder"
                    )}
                    onChange={handleTextFieldChange}
                    error={errors.value}
                    value={formValues.value}
                    required
                    endIcon=""
                  ></TextField>
                </div>
              </div>

              <div className="px-4 py-3 fixed left-0 bottom-0 bg-slate-50 border border-t-slate-200 w-full flex justify-end gap-3">
                <Button
                  variant="outlined"
                  children={t("admin.close")}
                  onClick={() => onClose()}
                />
                <Button
                  variant="primary"
                  children={t("admin.save")}
                  onClick={handleFormSubmit}
                />
              </div>
            </form>
          </div>
        </div>
      </div>

      <Loader isLoading={isLoading ?? false}> </Loader>
    </>
  );
};
export default memo(TranslationEditCard);
